import { render, staticRenderFns } from "./ItemTiers.vue?vue&type=template&id=1a1a92d9&"
import script from "./ItemTiers.vue?vue&type=script&lang=js&"
export * from "./ItemTiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports